import styled from 'styled-components'
import { white, grayDark, grayDarker } from '@bufferapp/ui/style/colors'

import { flexCol } from '~/shared/styles/layout'

export const OptionList = styled.ul`
  position: absolute;
  right: 16px;
  bottom: 16px;
  padding: 0;
  margin: 0;
  ${flexCol}
  list-style: none;
`

export const Option = styled.li`
  margin: 2px;
`

export const OptionButton = styled.button`
  width: 32px;
  height: 32px;
  background: ${white};
  border: 1px solid ${grayDark};
  border-radius: 50%;
  color: ${grayDark};
  ${flexCol}
  justify-content: center;
  cursor: pointer;

  &:hover,
  &:focus {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-color: ${grayDarker};
    color: ${grayDarker};
    outline: none;
  }
`
